import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getProducts } from 'app/entities/product/product.reducer';
import { getEntities as getTariffs } from 'app/entities/tariff/tariff.reducer';
import { createEntity, getEntity, reset, updateEntity } from './product-tariff-override.reducer';

export const ProductTariffOverrideUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const products = useAppSelector(state => state.product.entities);
  const tariffs = useAppSelector(state => state.tariff.entities);
  const productTariffOverrideEntity = useAppSelector(state => state.productTariffOverride.entity);
  const loading = useAppSelector(state => state.productTariffOverride.loading);
  const updating = useAppSelector(state => state.productTariffOverride.updating);
  const updateSuccess = useAppSelector(state => state.productTariffOverride.updateSuccess);

  const handleClose = () => {
    navigate('/product-tariff-override');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getProducts({}));
    dispatch(getTariffs({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.price !== undefined && typeof values.price !== 'number') {
      values.price = Number(values.price);
    }

    const entity = {
      ...productTariffOverrideEntity,
      ...values,
      product: products.find(it => it.id.toString() === values.product?.toString()),
      tariff: tariffs.find(it => it.id.toString() === values.tariff?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...productTariffOverrideEntity,
          product: productTariffOverrideEntity?.product?.id,
          tariff: productTariffOverrideEntity?.tariff?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="crawlerBackendApp.productTariffOverride.home.createOrEditLabel"
            data-cy="ProductTariffOverrideCreateUpdateHeading"
          >
            <Translate contentKey="crawlerBackendApp.productTariffOverride.home.createOrEditLabel">
              Create or edit a ProductTariffOverride
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="product-tariff-override-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.productTariffOverride.price')}
                id="product-tariff-override-price"
                name="price"
                data-cy="price"
                type="text"
              />
              <ValidatedField
                id="product-tariff-override-product"
                name="product"
                data-cy="product"
                label={translate('crawlerBackendApp.productTariffOverride.product')}
                type="select"
              >
                <option value="" key="0" />
                {products
                  ? products.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="product-tariff-override-tariff"
                name="tariff"
                data-cy="tariff"
                label={translate('crawlerBackendApp.productTariffOverride.tariff')}
                type="select"
              >
                <option value="" key="0" />
                {tariffs
                  ? tariffs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/product-tariff-override"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ProductTariffOverrideUpdate;
